export default {
  sm: `
  Natural environment for the 
  data center, Mountain 
  Gubong in Chuncheon-si
  `,
  md: `
  Natural environment for 
  the data center, 
  Mountain Gubong in 
  Chuncheon-si
  `,
  lg: `
  Natural environment for the data center, 
  Mountain Gubong in Chuncheon-si
  `
};
